import { Injectable } from "@angular/core";

import { LinksBaseConhecimentoService } from "./../../services/links-base-conhecimento.service";
import { UserToken } from "./user-token";

@Injectable({ providedIn: "root" })
export class AuthenticationService {
	USUARIO_LOGADO = "usuariologado";
	AUTENTICADO = "autenticado";
	ACCESS_TOKEN = "accessToken";

	constructor(
		private linksBaseConhecimentoService: LinksBaseConhecimentoService
	) {}

	obtenhaToken(): string {
		return sessionStorage.getItem(this.ACCESS_TOKEN);
	}

	estaAutenticado(): boolean {
		return sessionStorage.getItem(this.AUTENTICADO) === "S";
	}

	obtenhaUsuarioLogado(): UserToken {
		return JSON.parse(sessionStorage.getItem(this.USUARIO_LOGADO));
	}

	salvarUsuarioLogado(valor: any) {
		sessionStorage.setItem(this.USUARIO_LOGADO, JSON.stringify(valor));
		this.linksBaseConhecimentoService.salvarSessionStorage();
	}

	salvarUsuarioAutenticado(valor: any): any {
		sessionStorage.setItem(this.AUTENTICADO, valor);
	}

	salvarToken(valor: any): any {
		sessionStorage.setItem(this.ACCESS_TOKEN, valor);
	}

	limparSessao() {
		sessionStorage.clear();
	}

	usuarioTemPermissaoNaRota(rota) {
		const userToken = this.obtenhaUsuarioLogado();
		if (userToken && userToken.permissaoAcesso) {
			return userToken.permissaoAcesso.indexOf(rota) >= 0;
		} else {
			// TODO invalidar navegacao
		}

		return false;
	}

	usuarioAdministrador() {
		const userToken = this.obtenhaUsuarioLogado();
		return userToken.isAdministrador;
	}
}
